import styled from "styled-components";

export const Container = styled.div`
  width: 500px;
  display: flex;
  gap: 8px;
  padding: 0 32px 16px 32px;
`;

export const Card = styled.div`
  width: 100%;
  padding: 8px;
  gap: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  display: flex;
  align-items: center;
  img {
    width: 80px;
    height: 80px;
    border-radius: 10px;
  }
`;

export const IconHeader = styled.a`
  width: 80px;
  height: 80px;
  background-color: #eaefff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
`;

export const HeaderCard = styled.div`
  width: 100%;
  display: flex;
`;

export const BodyCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Text = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  //styleName: LG/Regular;
  font-family: Inter;
  line-height: 19.36px;
  letter-spacing: -0.01em;

  word-break: break-all;
  word-wrap: break-word;
`;

export const TextInfo = styled.p`
  //styleName: MD / Regular;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  word-break: break-all;
  word-wrap: break-word;
`;

export const Subtitle = styled.p`
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.16px;
  color: #8e8e8e;

  word-break: break-all;
  word-wrap: break-word;
`;
